<template>
  <footer
    class="relative bg-black text-white bg-cover bg-center bg-no-repeat"
    :class="{
      'bg-mobile-footer': true,
      'md:bg-desktop-footer': true
    }"
  >
    <div class="max-w-7xl mx-auto h-full">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 h-full items-center py-8 lg:py-0">
        <!-- Contact Form -->
        <div class="p-4 sm:p-6 lg:p-8 order-2 md:order-1">
          <!-- <h3 class="text-xl sm:text-2xl font-bold mb-4 lg:mb-6 text-white md:hidden text-center">
            {{ $t('footerSection.form.title') || '联系我们' }}
          </h3> -->
          <form @submit.prevent="handleSubmit">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 lg:gap-4 mb-3 lg:mb-4">
              <a-input
                v-model:value="formData.name"
                :placeholder="$t('footerSection.form.fullName')"
                class="bg-white rounded-md border-none h-10 sm:h-12"
              />
              <a-input
                v-model:value="formData.phone"
                :placeholder="$t('footerSection.form.phone')"
                class="bg-white rounded-md border-none h-10 sm:h-12"
              />
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 lg:gap-4 mb-3 lg:mb-4">
              <a-input
                v-model:value="formData.email"
                :placeholder="$t('footerSection.form.email')"
                class="bg-white rounded-md border-none h-10 sm:h-12"
              />
              <a-input
                v-model:value="formData.link"
                :placeholder="$t('footerSection.form.website')"
                class="bg-white rounded-md border-none h-10 sm:h-12"
              />
            </div>
            <a-textarea
              v-model:value="formData.remark"
              :placeholder="$t('footerSection.form.message')"
              :rows="3"
              class="bg-white rounded-md mb-4 lg:mb-6 border-none"
            />
            <div class="pb-4 sm:pb-6">
              <button
                class="w-full sm:w-auto bg-[#E0C9A6] text-black px-6 lg:px-8 py-2.5 lg:py-3 rounded-md font-medium hover:bg-[#d4b88d] transition-colors text-sm lg:text-base"
              >
                {{ $t('footerSection.form.submit') }}
              </button>
            </div>
          </form>
        </div>

        <!-- Contact Info -->
        <div class="flex flex-col justify-center p-4 sm:p-6 lg:p-8 order-1 md:order-2">
          <h2 class="text-2xl sm:text-3xl lg:text-3xl font-bold mb-4 lg:mb-6 text-white text-center md:text-left">
            {{ $t('footerSection.contact.title') }}
          </h2>
          <p class="text-gray-300 text-xs sm:text-sm lg:text-sm mb-6 lg:mb-8 leading-relaxed text-center md:text-left px-2 sm:px-0">
            {{ $t('footerSection.contact.description') }}
          </p>

          <div class="space-y-4 lg:space-y-6">
            <!-- 地址信息 -->
            <div
              class="flex items-start text-gray-300 text-xs sm:text-sm lg:text-sm border-b border-dashed border-white pb-2 lg:pb-3"
            >
              <div
                class="w-6 h-6 sm:w-8 sm:h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center mr-3 lg:mr-4 flex-shrink-0"
              >
                <span class="text-white text-xs sm:text-sm">📍</span>
              </div>
              <span class="leading-relaxed flex-1 pt-0.5 sm:pt-1">{{ $t('footerSection.contact.address') }}</span>
            </div>

            <!-- 邮箱信息 -->
            <div
              class="flex items-start text-gray-300 text-xs sm:text-sm lg:text-sm border-b border-dashed border-white pb-2 lg:pb-3"
            >
              <div
                class="w-6 h-6 sm:w-8 sm:h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center mr-3 lg:mr-4 flex-shrink-0"
              >
                <span class="text-white text-xs sm:text-sm">✉️</span>
              </div>
              <div class="leading-relaxed flex-1 pt-0.5 sm:pt-1">
                <div class="mb-2">
                  {{ $t('footerSection.contact.generalManager') }}: <span class="break-all">13336513549@163.com</span>
                </div>
                <div>
                  {{ $t('footerSection.contact.businessManager') }}: <span class="break-all">13336513549@163.com</span>
                </div>
              </div>
            </div>

            <!-- 电话信息 -->
            <div
              class="flex items-start text-gray-300 text-xs sm:text-sm lg:text-sm border-b border-dashed border-white pb-2 lg:pb-3"
            >
              <div
                class="w-6 h-6 sm:w-8 sm:h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center mr-3 lg:mr-4 flex-shrink-0"
              >
                <span class="text-white text-xs sm:text-sm">📞</span>
              </div>
              <div class="leading-relaxed flex-1 pt-0.5 sm:pt-1">
                <div class="mb-1">+86 13336513549</div>
                <div>+86 13336513549</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup name="Footer-Section">
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import tradeCustomerRecordApi from '@/api/tradeCustomerRecordApi.js'
  import backgroundImg from '../../../assets/other/WechatIMG3671.jpg'
  import backgroundImgMb from '../../../assets/mb/mmexport1750053681721.jpg'

  const { t } = useI18n()

  const formData = ref({
    name: '',
    phone: '',
    email: '',
    link: '',
    remark: ''
  })

  const handleSubmit = () => {
    console.log('Form submitted:', formData.value)
    tradeCustomerRecordApi
					.tradeCustomerRecordSubmitForm(formData.value, formData.value.id)
					.then(() => {
					})
  }
</script>

<style scoped>
/* 移动端背景图片 */
.bg-mobile-footer {
  background-image: url('../../../assets/mb/e7c0e917e2779722d7e1e12e980ff09.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  min-height: 500px;
  height: auto;
  width: auto;
}

/* 桌面端背景图片 */
@media (min-width: 768px) {
  .md\:bg-desktop-footer {
    background-image: url('../../../assets/other/WechatIMG3671.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    min-height: 500px;
    height: auto;
  }
}
</style>
